import {
  CheckBoxCellControlDisabled,
  InsertCol,
  DeleteColumn,
  InsertRow,
  DeleteRow,
  DoMergeCells,
  IsMergeDisabled,
  DoUnmergeCells
} from "@/appComponents/Blocks/Composites/LayoutHoverToolbar/Utils";
import { useEffect, useImperativeHandle, useRef } from "react";
import { GetDoc, GetWSMgr, ReRenderCanvas } from "@/Utils/StateLib";
import { ContextMenu } from "@/appComponents/Blocks/Composites/ContextMenu/ContextMenu";
import { Globals } from "@coreapp/CoreApp/Globals";
import {
  enumBoxSubTypes,
  enumContainerType,
  enumColInsert,
  enumHierarchyTypes
} from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

export const BoxCellContextMenu = props => {
  const openCtrlRef = useRef(null);
  useImperativeHandle(props.openCtrlRef, () => openCtrlRef.current);

  const handleClickCommand = cmd => () => {
    openCtrlRef.current?.setOpen(false);

    const wsMgr = GetWSMgr();
    if (!wsMgr) {
      return;
    }

    const cp = wsMgr.fCanvasPanel;
    cp["firstcell"] = props?.targetCell;

    const aCmd = wsMgr.AssembleCommand(props?.targetCell, cp, `DoCellAction-${cmd}`);
    aCmd["newvalue"] = cmd;
    wsMgr.HandleRightClickCmd("DoCellAction", aCmd);
    ReRenderCanvas();
  };

  let BLECellOptions = [
    {
      value: "insertrowabove",
      clickHandler: InsertRow,
      disabled: CheckBoxCellControlDisabled
    },
    {
      value: "insertrowbelow",
      clickHandler: () => InsertRow(false),
      disabled: CheckBoxCellControlDisabled
    },
    {
      value: "deleterows",
      clickHandler: DeleteRow,
      disabled: CheckBoxCellControlDisabled,
      icon: "trash",
      divider: true
    },
    {
      value: enumColInsert.insertLeft,
      clickHandler: InsertCol,
      disabled: CheckBoxCellControlDisabled
    },
    {
      value: enumColInsert.insertRight,
      clickHandler: () => InsertCol(false),
      disabled: CheckBoxCellControlDisabled
    },
    {
      value: "deletecols",
      clickHandler: DeleteColumn,
      disabled: CheckBoxCellControlDisabled,
      icon: "trash",
      divider: true
    },
    {
      value: "mergeall",
      clickHandler: DoMergeCells,
      disabled: IsMergeDisabled
    },
    {
      value: "unmergecells",
      clickHandler: DoUnmergeCells,
      disabled: IsMergeDisabled
    }
  ];

  const showLayoutOptions = () => {
    if (Globals._uiConfig.InBoxLayoutEditorMode()) return true;
    if (Globals._uiConfig.InBackgroundEditorMode() && props?.targetCell) {
      const targetCell = props.targetCell;
      const layout = targetCell.GetLayout();
      if (
        [enumBoxSubTypes.refBoxTable, enumBoxSubTypes.refBoxLegend].includes(layout.GetBoxSubType())
      )
        return true;
    }
    return false;
  };

  const getOptions = () => {
    const doc = GetDoc();
    if (!doc) return [];

    const showCellOptions = showLayoutOptions();
    if (showCellOptions) {
      const wsMgr = GetWSMgr();
      const bleLayout = wsMgr?.GetBLELayout();
      const isGroupBox =
        bleLayout?.GetContainerType() === enumContainerType.standardmrb &&
        bleLayout?.GetHierarchyType() === enumHierarchyTypes.grouping;
      const colInsertValues = [enumColInsert.insertLeft, enumColInsert.insertRight];
      return BLECellOptions.map(item => {
        return {
          ...item,
          label: appstr(item.value),
          disabled:
            item.disabled(item.value) || (isGroupBox && colInsertValues.includes(item.value)),
          dataTestId: `ble-rc-menu-${item.value}`
        };
      });
    } else {
      const actionList = props.targetCell?.GetRightClickActionList();
      if (actionList == null || actionList.length === 0) return;
      return actionList.map(item => {
        return {
          label: appstr(item.label),
          clickHandler: handleClickCommand(item.label),
          icon: item.icon,
          value: item.label,
          divider: item.divider
        };
      });
    }
  };

  let options = getOptions();

  useEffect(() => {
    if (!options || options.length === 0) {
      openCtrlRef?.current?.setOpen(false);
    }
  }, [options?.length]);

  const doc = GetDoc();
  if (!doc || options?.length === 0) return;

  return (
    <ContextMenu
      floatingCtrlRef={props.floatingCtrlRef}
      openCtrlRef={openCtrlRef}
      options={options ?? []}
      value={1}
    />
  );
};
